import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../../features/auth/services/auth.service';

/**
 * Who may open the product form at all. Regional users and managers pass to
 * *view* a product (the form renders read-only for them); authoring stays
 * with planAuthorGuard.
 */
export const planViewerGuard: CanActivateFn = async (route, state) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    await authService.profileReady();

    if (
        authService.isSuperUser ||
        authService.isSupervisor ||
        authService.isGlobal ||
        authService.isRegional ||
        authService.isManager
    ) {
        return true;
    }

    if (state.url !== '/no-access') {
        router.navigate(['/no-access']);
    }
    return false;
};
